import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _objectSpread from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchClueList as fetchList, fetchClueDelete as fetchDelete } from "@/api/PMS/customerService/lostAndFound/lostManagement";
import waves from "@/directive/waves"; // 水波纹指令

import { mapState } from "vuex";
export default {
  props: ["keyValue", "showDialog"],
  components: {},
  directives: {
    waves: waves
  },
  data: function data() {
    return {
      dialogImageUrl: "",
      downloadUrl: "",
      uploadUrl: "",
      dialogVisible: false,
      list: [],
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10
      },
      title: "",
      id: -1,
      deviceName: "",
      multipleSelection: [],
      dialogFormVisible: false
    };
  },
  computed: _objectSpread({}, mapState({
    userTheme: function userTheme(state) {
      return state.user.userTheme;
    }
  })),
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.listQuery = {
          page: 1,
          limit: 10
        };
        this.getList();
      }
    }
  },
  created: function created() {
    this.uploadUrl = process.env.VUE_APP_UPLOAD;
    this.downloadUrl = process.env.VUE_APP_DOWNLOAD;
    this.getList();
  },
  methods: {
    handlePreview: function handlePreview(url) {
      //   if (fileType === 2) {
      // 当附件是图片的时候在线打开
      console.log(url);
      this.dialogVisible = true;
      this.dialogImageUrl = url; //   }
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      this.listQuery.goodsSearchNoticeId = this.keyValue;
      fetchList(this.listQuery).then(function (response) {
        _this.list = response.data.data;
        console.log(_this.list);
        _this.total = response.data.total;
        _this.listLoading = false;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    delete: function _delete(ids) {
      var _this2 = this;

      if (ids.ids.length > 0) {
        this.$confirm("你确定是要删除这些线索, 是否继续?", "提示").then(function () {
          fetchDelete(ids).then(function (response) {
            if (response.data.code === 200) {
              _this2.getList();

              _this2.$emit("getList", true);

              _this2.Alert({
                alertType: "delete"
              });
            }
          });
        });
      } else {
        this.Alert({
          alertType: "nodata"
        });
      }
    },
    handleDelete: function handleDelete(id) {
      var ids = {
        ids: []
      };
      ids.ids.push(id);
      this.delete(ids);
    },
    handleDeletes: function handleDeletes() {
      var ids = {
        ids: []
      };
      this.multipleSelection.forEach(function (row) {
        ids.ids.push(row.id);
      });
      this.delete(ids);
    },
    handCancle: function handCancle(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogFormVisible = false;
    }
  }
};